// React
import React from 'react'

// Packages
import { Container } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

// Packages
import LoginForm from '../../components/Login/LoginForm/index.js';
import LoginHeader from '../../components/Login/LoginHeader/index.js';
import LoginSideImage from '../../components/Login/LoginSideImage/index.js';

import styles from './LoginStyles.js';

const Login = () => {
  return (
    <Grid container sx={styles.gridContainer}>
      <LoginSideImage />
      <Grid xs={12} md={6} style={{ backgroundColor: 'white', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}>
        <Container sx={styles.contentContainer}>
          <LoginHeader />
          <LoginForm />
        </Container>
      </Grid>
    </Grid>
  );
}

export default Login
